import { Box, Grid, Typography } from "@mui/material";
import styles from "./MassMailing.module.css";
import MassMailingTable from "./MassMailingTable";
import { useNavigate } from "react-router-dom";
import TableCard from "../../components/common/TableCard";
import JobListDrawer from "./JobListDrawer";
import { useEffect, useState } from "react";
import JobViewMassmailDrawer from "./JobViewMassmailDrawer";
import SearchMassMail from "./SearchMassMail";
import { useDispatch, useSelector } from "react-redux";
import { getAllMassmailHistory } from "../../redux/massmail/massmailSlice";

const CompanyList = () => {
  const navigate = useNavigate();
  const [jobTitles, setJobTitles] = useState([]);
  const [show, setShow] = useState(false);
  const [showJob, setShowJob] = useState(false);
  const [jobID, setJObID] = useState("");
  const handleCloseShow = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleCloseShowJob = () => setShowJob(false);
  const handleShowJob = () => setShowJob(true);
  const [massMailingHistoryList, setMassMailingHistoryList] = useState([]);
  const [massMailingHistory, setMassMailingHistory] = useState([]);
  const [searchData, setSearchData] = useState({
    requirement_type: [],
    client_name: "",
    locations: [],
    job_title: [],
  });

  const [page, setPages] = useState(1);
  const [pagination, setPagination] = useState({
    current_page: 1,
    has_next: false,
    has_previous: false,
    next_page: null,
    previous_page: null,
    total_pages: 1,
  });

  const dispatch = useDispatch();
  const historyData = useSelector((state) => state.massmail.historyData);

  useEffect(() => {
    dispatch(getAllMassmailHistory(`page=${page}`));
  }, []);

  const handlePageChange = (event, value) => {
    setPages(value);
  };

  // useEffect(() => {
  //   if (historyData) {
  //     setPagination({
  //       current_page: historyData?.current_page,
  //       has_next: historyData?.has_next,
  //       has_previous: historyData?.has_previous,
  //       next_page: historyData?.next_page,
  //       previous_page: historyData?.previous_page,
  //       total_pages: historyData?.total_pages,
  //     });
  //   }
  // }, [historyData]);

  useEffect(() => {
    setMassMailingHistoryList(historyData?.results);
    setMassMailingHistory(historyData?.results);
  }, [historyData]);

  useEffect(() => {
    if (massMailingHistoryList?.length > 0) {
      const jobTitle = massMailingHistoryList
        ?.map((requirement) => requirement.job_title)
        .filter(
          (title, index, self) => title && self?.indexOf(title) === index
        );
      setJobTitles(jobTitle);
    }
  }, [massMailingHistoryList]);

  const handleOnClear = () => {
    setSearchData({
      requirement_type: [],
      client_name: "",
      locations: [],
      job_title: [],
    });
    dispatch(getAllMassmailHistory(""));
  };

  const handleOnClickSearch = () => {
    // useEffect(() => {
    if (searchData) {
      console.log({ searchData });
      const queryParams = Object.keys(searchData).reduce((acc, key) => {
        const value = searchData[key];
        console.log({ value });

        if (Array.isArray(value) && value.length > 0) {
          acc[key] = JSON.stringify(value);
        } else if (
          value !== "" &&
          value !== null &&
          value !== undefined &&
          !Array.isArray(value)
        ) {
          acc[key] = value;
        }
        return acc;
      }, {});

      console.log("Filtered Query Params:", queryParams);

      const reqQueryString = Object.entries(queryParams)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");

      // const reqQueryString = `job_title=${searchData?.job_title}&location=${searchData?.location}&requirement_type=${searchData?.requirement_type}$end_date=${searchData?.end_date}$start_date=${searchData?.start_date}`;

      console.log("Final Query String:", reqQueryString);

      dispatch(getAllMassmailHistory(reqQueryString));
    } else {
      dispatch(getAllMassmailHistory(""));
    }
    // }, [searchData, dispatch]);
  };

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#e5e7eb",
          paddingTop: "15px",
          margin: "14px",
          paddingBottom: "15px",
        }}
      >
        <Box className={styles.candidate_listing_text}>
          <span>
            <Typography
              sx={{ color: "customTextColor", fontSize: "20px !important" }}
            >
              <b>BE SURE WHAT AND SENT TO WHOM </b>
            </Typography>
            <Typography sx={{ color: "customTextColor" }}>
              <b>Fully transparent report will send you every month </b>
            </Typography>
          </span>
          <span>
            <button
              style={{ backgroundColor: "#3856a6", marginRight: "20px" }}
              onClick={handleShow}
            >
              New Mass Mail
            </button>

            {/* <span className={styles.add_btns}>
              <button
                style={{ marginLeft: "15px", backgroundColor: "#4285f4" }}
              >
                Filter Report
              </button>
            </span> */}
          </span>
        </Box>
        {/* 
        <Grid container>
          <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
            <TableCard
              count="12"
              text="Mass Mailing"
              customStyle="10px 10px 0 20px; background-color: white;"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
            <TableCard
              count="25k"
              text="Send to Bench Sales"
              customStyle={{ backgroundColor: "white" }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
            <TableCard
              count="10k"
              text="Sent to Candidate "
              customStyle={{ backgroundColor: "white" }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
            <TableCard
              count="5k"
              text="Credit Deducted "
              customStyle="10px 20px 0 5px; background-color: white;"
            />
          </Grid>
        </Grid> */}
      </Box>

      <SearchMassMail
        handleOnClear={handleOnClear}
        jobTitles={jobTitles}
        setSearchData={setSearchData}
        searchData={searchData}
        handleOnClickSearch={handleOnClickSearch}
      />

      <MassMailingTable
        historyData={massMailingHistory}
        pagination={pagination}
        page={page}
        handlePageChange={handlePageChange}
      />
      <JobListDrawer
        handleShow={handleShow}
        handleClose={handleCloseShow}
        show={show}
        handleShowJob={handleShowJob}
        setJObID={setJObID}
      />

      <JobViewMassmailDrawer
        handleShow={handleShowJob}
        handleClose={handleCloseShowJob}
        show={showJob}
        jobID={jobID}
      />
    </>
  );
};

export default CompanyList;
